module.exports = __webpack_public_path__ + "img/football-dark.18cd3fb7.svg";